::ng-deep particle-task-manager-list{display:flex;width:100%;height:100%}
/*# sourceMappingURL=task-manager-my-ticket-list.component-X4VH7B4J.css.map */
